import type { AuthUser } from "../context/AuthContext";

export const PUBLISHER_AUTH_ENTRY_PATHS = new Set(["/sign-in", "/log-in"]);
export const FOUNDER_AUTH_ENTRY_PATHS = new Set([
  "/founder/log-in",
  "/founder/set-password",
]);

export function isAuthenticatedPublisher(user: AuthUser | null): boolean {
  return user?.role === "publisher";
}

export function isAuthenticatedFounder(user: AuthUser | null): boolean {
  return user?.role === "founder";
}
